/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * KHOÁ VÌ QUYỀN — MỘT chỗ vẽ, cho MỌI chỗ khoá. (`P-6` `B4` bổ sung, lee góp ý 10/09.)
 *
 * 🔴 VẤN ĐỀ CÓ THẬT, lee nhìn ra trên máy: màn hình đang có **BA trạng thái cùng màu xám**, và
 *   người dùng không phân biệt được chúng:
 *
 *     tủ mất kết nối       ĐỎ    — đã có sẵn (`nguy`)
 *     đang tải             XÁM   — `Spinner`, thoáng qua
 *     không có quyền       XÁM   ← lẫn vào hai cái trên, và nó KHÔNG thoáng qua
 *
 *   Ba câu ấy dẫn tới ba việc khác hẳn nhau: *đi kiểm tra tủ* · *chờ một giây* · **hỏi người
 *   cấp quyền**. Vẽ chúng cùng một màu là bắt người dùng đoán mình đang ở ca nào — đúng cái
 *   dự án này đã cắt ở `cauChanCoTuyen` (bốn ca, bốn câu), chỉ lần này ở phần NHÌN.
 *
 * ⇒ Khoá vì quyền có **màu riêng**: hổ phách, viền nhạt, biểu tượng ổ khoá, huy hiệu
 *   *"Chỉ xem"* hoặc *"Không có quyền: <tên>"*. Không đỏ *(không phải sự cố)*, không xám trần
 *   *(không phải đang tải)*.
 *
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * ➕ `GD-01` 11/09/2026 — DỌN SANG **FLUENT UI v9** (Microsoft), giữ nguyên ba thứ lee đã chốt:
 *   **màu hổ phách · ổ khoá · câu "Người cấp quyền: @…"**. Chỉ đổi vỏ, không đổi một nghĩa nào.
 *
 *     HuyHieuKhoa  ->  <Badge color="warning" icon={<LockClosed16Regular/>}>
 *     BangKhoa     ->  <MessageBar intent="warning">
 *     KhoiKhoa     ->  MessageBar + lớp mờ/không bấm được (giữ nguyên `pointer-events-none`)
 *
 * ⛔ VÀ MÀU NAY LÀ **TOKEN**, không phải mã màu hay lớp Tailwind màu.
 *
 * ➕ `GD-02` 11/09 — màu khoá đổi từ dải hổ phách CỦA FLUENT sang `--canh` của `thietke.css`,
 *   **cùng một biến với mọi chỗ "cần chú ý" khác trong app**. Lý do không phải thẩm mỹ: hai hệ
 *   màu chạy song song ở đây *(Tailwind đọc `--canh`, Fluent đọc `colorPaletteYellow*`)*, và
 *   hai dải cam gần giống nhau trên cùng một màn hình đọc ra *"có gì đó hơi bẩn"* mà không chỉ
 *   được ra chỗ nào. Một biến, một màu cam.
 * ⚠ VÀ NHỜ THẾ CHẾ ĐỘ SÁNG TỰ ĐÚNG: `:root[data-che-do="sang"]` đổi `--canh`/`--canh-nen`, khối
 *   khoá đổi theo, không một dòng `.tsx` nào phải biết. *(Phép phá của `GD-02` đo đúng điều này.)*
 * ➕ VIỀN ĐỨT (`dashed`) — mẫu lee duyệt. Nó nói *"chỗ này bị chặn"* trước cả khi mắt đọc chữ,
 *   và nó phân biệt khối khoá với thẻ thường mà không cần thêm một màu nào nữa.
 * ⚠ Tailwind **chỉ còn cho bố cục** ở tệp này (`flex`, `gap`, `opacity`, `pointer-events-none`) —
 *   không một lớp MÀU nào. Đó là ranh giới `GD-01` mục 4 vạch ra, và nó đo được.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *
 * ⛔ VÀ MỘT TÍNH CHẤT KHÔNG PHẢI THẨM MỸ: `pointer-events-none` nằm ở ĐÂY, trong cùng khối vẽ
 *   ra vẻ "mờ". Nghĩa là **cái nhìn và cái bấm được đến từ một chỗ** — một nút quên `disabled`
 *   vẫn không bấm được khi đã bọc `<Khoa>`. Hai thứ ấy tách ra là chỗ đẻ ra nút "trông như
 *   khoá mà vẫn ăn".
 *
 * ⛔ KHÔNG AI TỰ VẼ XÁM TAY. Đây là chỗ DUY NHẤT trong `web/src` được phép: dùng biểu tượng ổ
 *   khoá, viết chữ *"Chỉ xem"* / *"Không có quyền"*, và gọi `cauChanCoTuyen()`. Mục `[95]`
 *   của `verify-protocol.ts` canh đúng ba điều đó — vì một kiểu vẽ được sao chép ba nơi là ba
 *   nơi sẽ trôi khỏi nhau, và chỗ trôi sẽ là chỗ người dùng đọc nhầm.
 *
 * ⚠ ĐÂY VẪN KHÔNG PHẢI MỘT CỬA QUYỀN. Cửa thật ở máy chủ (`requireQuyen`/`requireCoTuyen`).
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
import type { ReactNode } from 'react';
import { Badge, MessageBar, MessageBarBody, makeStyles, tokens } from '@fluentui/react-components';
import { LockClosed16Regular } from '@fluentui/react-icons';
import { NHAN_CO_TUYEN, NHAN_KHOA, cauChanCoTuyen, type CoTuyen, type QuyetDinhCoTuyen } from '../lib/quyen';
import { useAuth, useNguoiCap } from '../lib/auth';

/**
 * ⚠ DÙNG THUỘC TÍNH DÀI (`borderTopWidth`…), KHÔNG dùng `border`/`padding` viết tắt.
 *
 * `makeStyles` của Fluent chạy trên Griffel, và Griffel từng **từ chối thuộc tính viết tắt**
 * (phải đi qua `shorthands.border(...)`). Bản mới nhận được, nhưng thuộc tính dài thì đúng ở
 * MỌI bản — và tệp này không typecheck được trong hộp cát của dev_app, nên tôi chọn cách không
 * có cửa để sai.
 */
const useKhoaStyles = makeStyles({
  /** Khối bọc một nút/ô bị khoá — viền cam ĐỨT, nền cam rất nhạt. Cả hai từ `thietke.css`. */
  vo: {
    borderTopWidth: tokens.strokeWidthThin,
    borderRightWidth: tokens.strokeWidthThin,
    borderBottomWidth: tokens.strokeWidthThin,
    borderLeftWidth: tokens.strokeWidthThin,
    borderTopStyle: 'dashed',
    borderRightStyle: 'dashed',
    borderBottomStyle: 'dashed',
    borderLeftStyle: 'dashed',
    borderTopColor: 'rgb(var(--canh) / 0.55)',
    borderRightColor: 'rgb(var(--canh) / 0.55)',
    borderBottomColor: 'rgb(var(--canh) / 0.55)',
    borderLeftColor: 'rgb(var(--canh) / 0.55)',
    backgroundColor: 'rgb(var(--canh-nen))',
    color: 'rgb(var(--canh))',
    borderRadius: tokens.borderRadiusMedium,
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
  },
  /**
   * Băng đầu khối. `MessageBar intent="warning"` của Fluent mang dải cam RIÊNG của nó; ép nó
   * về `--canh` để một màn hình chỉ có MỘT sắc cam.
   * ⛔ `!important` không cần: lớp `makeStyles` truyền qua `className` đứng sau lớp mặc định
   *   của Fluent trong thứ tự chèn, nên nó thắng mà không phải la lên.
   */
  /*
   * ═══════════════════════════════════════════════════════════════════════════════════════
   * ➕ `GD-02c` 11/09/2026 — BĂNG KHÔNG ĐƯỢC TRÀN RA NGOÀI MÉP (lỗi 5 lee chụp ở ~1100 px:
   * *"…Vận hành · "Tạ"* — chữ bị cắt ngang ở mép phải cột).
   *
   * 🔴 GỐC KHÔNG NẰM Ở BĂNG, NÓ NẰM Ở LUẬT MẶC ĐỊNH CỦA FLEX/GRID: một con flex hay grid có
   *   `min-width: auto`, tức là **không bao giờ hẹp hơn nội dung của nó**. `MessageBar` của
   *   Fluent là một lưới; câu dài không có chỗ ngắt (một chuỗi tên tính năng nối bằng `·`) đẩy
   *   nó rộng hơn cột, và phần thừa bị cột cha cắt đi. Đây ĐÚNG cùng một lỗi đã sửa cho băng
   *   lỗi ở chân hộp (`bangLoi` — `minWidth: 0`), lần này ở một băng khác.
   * ⇒ Sửa Ở ĐÂY, một lần, cho MỌI chỗ dựng băng — bốn trang đang dùng nó. Sửa ở chỗ gọi là
   *   dựng lại đúng cái vừa gom, và trang thứ năm sẽ lại tràn.
   *
   * ⛔ BA THỨ ĐI CÙNG NHAU hoặc không thứ nào chạy:
   *     `minWidth: 0`        — cho băng co hẹp hơn nội dung
   *     `maxWidth: '100%'`   — chặn nó vượt cột cha
   *     `whiteSpace/overflowWrap` ở THÂN — cho chữ XUỐNG DÒNG thay vì bị cắt
   *   Thiếu vế cuối thì băng co lại đúng bề ngang cột rồi cắt chữ ở mép — trông y hệt lỗi cũ.
   * ⚠ `overflowWrap: 'anywhere'` chứ không `break-word`: một chuỗi như `khach_hang_11` hay một
   *   dãy nhãn nối bằng `·` KHÔNG có chỗ ngắt hợp lệ nào, và `break-word` chỉ ngắt khi từ đó
   *   một mình đã dài quá dòng. `anywhere` ngắt được ở bất cứ đâu — xấu hơn một chút, và đọc
   *   được, còn cái kia thì mất chữ.
   * ═══════════════════════════════════════════════════════════════════════════════════════
   */
  bang: {
    minWidth: 0,
    maxWidth: '100%',
    borderTopStyle: 'dashed',
    borderRightStyle: 'dashed',
    borderBottomStyle: 'dashed',
    borderLeftStyle: 'dashed',
    borderTopColor: 'rgb(var(--canh) / 0.55)',
    borderRightColor: 'rgb(var(--canh) / 0.55)',
    borderBottomColor: 'rgb(var(--canh) / 0.55)',
    borderLeftColor: 'rgb(var(--canh) / 0.55)',
    backgroundColor: 'rgb(var(--canh-nen))',
    color: 'rgb(var(--canh))',
  },
  /** Thân băng — chỗ chữ phải xuống dòng. Xem khối chú thích ở `bang` ngay trên. */
  thanBang: {
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
  },
  /** Trạng thái CHƯA ĐO ĐƯỢC — xám trung tính, đúng nghĩa xám của `[95]`. */
  dangDo: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground3,
  },
  /**
   * ➕ `GD-09b` — BẢN XÁM CỦA `vo`: **cùng hình, khác màu**.
   *
   * 🔴 Cùng hình là cố ý: người dùng học "cái khung đứt nét này = chưa bấm được" bằng mắt. Đổi
   *   cả hình lẫn màu là dựng hai thứ trông không liên quan cho hai trạng thái kề nhau, và
   *   trạng thái xám sống vài trăm mili-giây rồi biến thành một trong hai cái kia — một cú
   *   nhảy hình sẽ đọc ra như "màn hình vừa vỡ".
   * ⛔ Và KHÁC MÀU là bắt buộc: hổ phách ở dự án này có MỘT nghĩa (`[95]`) — *"bạn thiếu quyền,
   *   đi hỏi người cấp"*. Đó là một LỜI KHAI. Xám là *"chưa đo được"*.
   */
  voDangDo: {
    borderTopWidth: tokens.strokeWidthThin,
    borderRightWidth: tokens.strokeWidthThin,
    borderBottomWidth: tokens.strokeWidthThin,
    borderLeftWidth: tokens.strokeWidthThin,
    borderTopStyle: 'dashed',
    borderRightStyle: 'dashed',
    borderBottomStyle: 'dashed',
    borderLeftStyle: 'dashed',
    borderTopColor: tokens.colorNeutralStroke2,
    borderRightColor: tokens.colorNeutralStroke2,
    borderBottomColor: tokens.colorNeutralStroke2,
    borderLeftColor: tokens.colorNeutralStroke2,
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground3,
    borderRadius: tokens.borderRadiusMedium,
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
  },
  /** Huy hiệu — cùng một biến, khác độ đục. */
  /* Vận hành 24/10 (bên kiểm vòng 2): khung khoá TRUNG TÍNH cho nút điều khiển nằm trong thẻ — viền đứt màu viền, không nền cam
     (cam là màu cảnh báo). Ổ khoá + câu "Không có quyền" vẫn ở `title`; nút vẫn mờ + không bấm được. */
  voTrungTinh: {
    borderTopWidth: tokens.strokeWidthThin,
    borderRightWidth: tokens.strokeWidthThin,
    borderBottomWidth: tokens.strokeWidthThin,
    borderLeftWidth: tokens.strokeWidthThin,
    borderTopStyle: 'dashed',
    borderRightStyle: 'dashed',
    borderBottomStyle: 'dashed',
    borderLeftStyle: 'dashed',
    borderTopColor: 'rgb(var(--vien-manh))',
    borderRightColor: 'rgb(var(--vien-manh))',
    borderBottomColor: 'rgb(var(--vien-manh))',
    borderLeftColor: 'rgb(var(--vien-manh))',
    borderRadius: tokens.borderRadiusMedium,
    paddingTop: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
  },
  huyHieu: {
    backgroundColor: 'rgb(var(--canh) / 0.18)',
    color: 'rgb(var(--canh))',
    borderTopColor: 'rgb(var(--canh) / 0.5)',
    borderRightColor: 'rgb(var(--canh) / 0.5)',
    borderBottomColor: 'rgb(var(--canh) / 0.5)',
    borderLeftColor: 'rgb(var(--canh) / 0.5)',
  },
});

/**
 * Huy hiệu hổ phách. `ten` rỗng ⇒ *"Chỉ xem"*; có ⇒ *"Không có quyền: <tên>"*.
 *
 * ⚠ Hai câu, không phải một: *"Chỉ xem"* nói **trạng thái của tôi**; *"Không có quyền: Cài
 *   chiến lược"* nói **cái còn thiếu**, tức là thứ người ta đi xin. Chỗ nào biết tên thì phải
 *   nói tên ra — một câu chung chung là một câu người dùng không mang đi hỏi ai được.
 */
export function HuyHieuKhoa({ ten, className = '' }: { ten?: string; className?: string }) {
  const s = useKhoaStyles();
  return (
    <Badge
      color="warning"
      appearance="tint"
      size="medium"
      icon={<LockClosed16Regular />}
      className={`${s.huyHieu} ${className}`}
    >
      {ten ? `Không có quyền: ${ten}` : 'Chỉ xem'}
    </Badge>
  );
}

/**
 * Bọc một nút / công tắc / ô nhập bị khoá VÌ QUYỀN.
 *
 * @param ten   tên tick hoặc cờ còn thiếu — hiện trên huy hiệu, và là thứ người dùng đi xin.
 * @param moTa  câu đầy đủ cho `title` (rê chuột).
 * @param hienHuyHieu  tắt khi khối cha đã có băng `BangKhoa` — đừng lặp một câu ba lần trên
 *                     cùng một khung nhìn (lee góp ý: một băng gọn, thay câu lặp ở từng ngõ ra).
 */
export function Khoa({
  children, ten, moTa, hienHuyHieu = true, className = '', trungTinh = false,
}: {
  children: ReactNode;
  ten?: string;
  moTa?: string;
  hienHuyHieu?: boolean;
  className?: string;
  /** khung viền trung tính (không cam) — xem `voTrungTinh` */
  trungTinh?: boolean;
}) {
  const s = useKhoaStyles();
  return (
    <span
      className={`${trungTinh ? s.voTrungTinh : s.vo} relative inline-flex max-w-full flex-wrap items-center gap-2 ${className}`}
      title={moTa ?? (ten ? `Không có quyền: ${ten}` : 'Bạn chỉ có quyền xem')}
    >
      {/* ⛔ `pointer-events-none` + `select-none`: KHÔNG bấm được, kể cả khi con quên `disabled`.
          `min-w-0 max-w-full` (vòng 2): nội dung có chữ `truncate` không được đẩy khung rộng hơn thẻ chứa nó (đo 527 px ở 390). */}
      <span className="pointer-events-none min-w-0 max-w-full select-none opacity-50">{children}</span>
      {hienHuyHieu && <HuyHieuKhoa ten={ten} />}
    </span>
  );
}

/**
 * KHOÁ CẢ MỘT KHỐI (một mục của form, một thẻ) — bản KHỐI của `<Khoa>`.
 *
 * 🔴 Vì sao cần bản thứ hai thay vì bọc `<Khoa>` quanh mọi thứ: `<Khoa>` là `inline-flex`, dựng
 *   cho một cái nút / một công tắc. Bọc nó quanh sáu ô nhập thì cách dòng vỡ và huy hiệu trôi ra
 *   giữa nội dung. Nhưng phần ĐẮT của nó — `pointer-events-none` nằm cùng khối với vẻ mờ — thì
 *   giống hệt, nên nó ở **cùng tệp này** chứ không phải một kiểu xám ai đó tự vẽ ở trang khác.
 *
 * ⛔ `<fieldset disabled>` KHÔNG thay được: nó chỉ tắt ô nhập, không tắt một `<div onClick>` hay
 *   một nút tự vẽ — mà form Quản trị đầy những thứ ấy. `pointer-events` không phân biệt: cái gì
 *   nằm trong khối thì không bấm được, kể cả thứ chưa ai nghĩ tới.
 */
export function KhoiKhoa({
  children, cau, ten, className = '',
}: {
  children: ReactNode;
  /** Câu của băng đầu khối. Bỏ trống ⇒ câu mặc định của `BangKhoa`. */
  cau?: string;
  ten?: string;
  className?: string;
}) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <BangKhoa cau={cau} ten={ten} />
      <div className="pointer-events-none select-none opacity-50">{children}</div>
    </div>
  );
}

/**
 * BĂNG GỌN ĐẦU KHỐI — thay cho câu lặp ở từng ngõ ra (lee đặt hàng).
 *
 * 🔴 Nó phải trả lời được câu *"vậy tôi hỏi ai"*. Một dòng *"bạn không có quyền"* mà không nói
 *   ai cấp là một ngõ cụt: người dùng sẽ đi hỏi tổng đài, hoặc bỏ cuộc.
 *
 * ✅ 10/09 (lượt 58) — CÁI TÊN ĐÃ CÓ. `/api/auth/me` nay trả `nguoiTao: { username }`, nên băng
 *   in được *"Người cấp quyền: @main_custom."*.
 *
 * ⛔ VÀ BĂNG TỰ ĐI LẤY TÊN, KHÔNG CHỜ CHỖ GỌI TRUYỀN VÀO. Bốn trang đang dựng băng này; bắt cả
 *   bốn nhớ truyền `nguoiCap` là dựng lại đúng cái vừa gom — trang thứ năm ai đó thêm mai sau
 *   sẽ quên, và nó **không đỏ ở đâu cả**, chỉ mất một cái tên mà không ai thấy thiếu. Ở đây thì
 *   quên là không quên được: chỗ gọi không có gì để quên.
 *
 * ⚠ Ba nghĩa của `nguoiCap`, và chúng KHÔNG gộp:
 *     bỏ trống (`undefined`) → **tự hỏi** `useNguoiCap()` — đây là ca thường
 *     `null`                 → chỗ gọi CỐ Ý bảo "đừng in tên"
 *     `'ten'`                → in tên ấy (chỗ gọi biết rõ hơn: cây tài khoản, người khác tôi)
 *   Nếu tôi để `null` cũng đi hỏi context thì mất luôn đường tắt "cố ý im" — lại đúng cái bẫy
 *   *một giá trị mang hai nghĩa* mà Luật số 0 nói.
 */
export function BangKhoa({
  cau, ten, nguoiCap, className = '',
}: {
  /** Câu chính. Bỏ trống ⇒ câu mặc định "chỉ có quyền xem". */
  cau?: string;
  ten?: string;
  nguoiCap?: string | null;
  className?: string;
}) {
  const s = useKhoaStyles();
  const tuMe = useNguoiCap();
  const ten_nguoi_cap = nguoiCap === undefined ? tuMe : nguoiCap;
  return (
    <MessageBar intent="warning" icon={<LockClosed16Regular />} className={`${s.bang} ${className}`}>
      <MessageBarBody className={s.thanBang}>
        {cau ?? 'Bạn chỉ có quyền XEM ở khu vực này.'}
        {ten ? <> Thiếu quyền: <b>{ten}</b>.</> : null}
        {' '}
        {ten_nguoi_cap
          ? <>Người cấp quyền: <b>@{ten_nguoi_cap}</b>.</>
          : <>Hỏi người đã tạo tài khoản cho bạn để được cấp thêm.</>}
      </MessageBarBody>
    </MessageBar>
  );
}

/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * ➕ `GD-09b` 14/09/2026 — CÂU "CHƯA BIẾT", **MỘT BẢN**.
 *
 * 🔴 Trước phiếu này câu ấy tồn tại BA bản: một chuỗi gõ tay trong `BangKhoaTuyen`, một chuỗi
 *   gõ tay trong `cauKhoaTuyen()`, và một cái chấm xám + chữ *"đang kiểm quyền…"* tự vẽ trong
 *   `Dashboard.tsx`. Ba bản cho một trạng thái là ba thứ sẽ trôi khỏi nhau — và ở đây chúng
 *   ĐÃ trôi: hai bản viết hoa chữ đầu, bản thứ ba không; hai bản có khung xám, bản thứ ba là
 *   chữ trần. Cùng một họ với `OSoLon` hai bản (`GD-09`) và `quyetDinhCoTuyen` hai bản.
 * ⛔ Và đây là chỗ luật `[95]` được giữ: dấu này **không bao giờ hổ phách**. Hổ phách là lời
 *   khai *"bạn thiếu quyền"*; lúc chưa hỏi xong `/me` thì ta không có gì để khai.
 * ⚠ MỘT HÌNH cho cả ba chỗ (băng đầu khối · dưới thẻ tuyến · dưới thẻ ngõ ra): người dùng học
 *   "hình này = đang đo" bằng mắt, không bằng chỗ nó đứng.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
export const CAU_DANG_KIEM = 'Đang kiểm quyền trên tuyến này…';
/**
 * ⚠ HAI CÂU, KHÔNG MỘT — và đúng theo `A.3`: *tick nói LÀM GÌ, tuyến nói Ở ĐÂU*. Một ô khoá vì
 *   thiếu TICK không dính gì tới tuyến nào cả, nên mượn câu *"trên tuyến này"* cho nó là nói
 *   sai chỗ, y như bốn câu của `cauChanCoTuyen` không mượn được cho nhau.
 */
export const CAU_DANG_KIEM_TICK = 'Đang kiểm quyền của tài khoản…';

export function DauDangKiem({ cau = CAU_DANG_KIEM, className = '' }: {
  cau?: string; className?: string;
}) {
  const s = useKhoaStyles();
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs ${s.dangDo} ${className}`}>
      <span className="h-1.5 w-1.5 shrink-0 animate-pulse rounded-full bg-chua-ro" />
      {cau}
    </span>
  );
}

/**
 * BỌC MỘT NÚT ĐANG Ở CA "CHƯA BIẾT" — bản XÁM của `<Khoa>`, cùng hình, khác màu, cùng cái cổng.
 *
 * ⛔ MỘT chỗ vẽ cho cả hai tầng quyền (TICK và CỜ TUYẾN). Hai tầng ấy hỏi hai câu khác nhau
 *   (*"tôi có tick này không"* · *"tôi có cờ này TRÊN TUYẾN NÀY không"*) nhưng ca "chưa hỏi
 *   xong" của chúng là MỘT — cùng `daBietQuyen`, cùng cái nghĩa, nên cùng một hình.
 * ⚠ `pointer-events-none` giữ nguyên như `<Khoa>`: chưa biết thì chưa cho bấm (hỏng về phía
 *   ĐÓNG). Cái đổi là màu và câu chữ, không phải cái cổng.
 */
export function BocDangDo({ children, hienHuyHieu = true, className = '', cau = CAU_DANG_KIEM }: {
  children: ReactNode; hienHuyHieu?: boolean; className?: string; cau?: string;
}) {
  const s = useKhoaStyles();
  return (
    <span
      className={`${s.voDangDo} relative inline-flex max-w-full flex-wrap items-center gap-2 ${className}`}
      title={cau}
    >
      <span className="pointer-events-none min-w-0 max-w-full select-none opacity-50">{children}</span>
      {hienHuyHieu && <DauDangKiem cau={cau} />}
    </span>
  );
}

/**
 * Băng cho một quyết định CỜ TUYẾN — bốn ca, bốn câu, và câu do `cauChanCoTuyen()` dựng.
 *
 * ⛔ `cauChanCoTuyen` chỉ được gọi Ở ĐÂY. Rải nó ra từng trang là dựng lại đúng cái vừa gom:
 *   ba trang sẽ có ba cách nói về cùng một tình huống.
 */
export function BangKhoaTuyen({
  qd, co, nguoiCap, className = '',
}: {
  qd: QuyetDinhCoTuyen | 'khong-co-tuyen' | 'chua-biet';
  co: CoTuyen;
  nguoiCap?: string | null;
  className?: string;
}) {
  /* Được phép thì KHÔNG vẽ gì — băng chỉ tồn tại khi có thứ để nói. */
  if (qd === 'cho-qua') return null;
  /*
   * ═══════════════════════════════════════════════════════════════════════════════════════
   * ➕ `GD-09` — CA `'chua-biet'`: XÁM, KHÔNG HỔ PHÁCH.
   *
   * 🔴 Hổ phách ở dự án này có MỘT nghĩa (`[95]`): *"cần người xử lý — bạn thiếu quyền, đi hỏi
   *   người cấp"*. Đó là một LỜI KHAI về tài khoản của người đang đọc. Lúc `/api/auth/me` chưa
   *   trả lời thì ta không có gì để khai, và vẽ hổ phách là **gửi người ta đi hỏi xin một thứ
   *   họ có thể đang có sẵn** — đúng cái lee gặp: thẻ HHG ghi "🔒 Chỉ xem" trong khi tài khoản
   *   ấy CÓ `canControl` trên HHG.
   * ⛔ Xám là màu "đang tải / chưa đo được" của `[95]` — đúng nghĩa, và nó không sai được:
   *   trạng thái này sống vài trăm mili-giây rồi tự trả lời.
   * ═══════════════════════════════════════════════════════════════════════════════════════
   */
  if (qd === 'chua-biet') return <DauDangKiem className={className} />;
  return (
    <BangKhoa
      cau={cauChanCoTuyen(qd, co)}
      ten={qd === 'khong-co-co' ? NHAN_CO_TUYEN[co] : undefined}
      nguoiCap={nguoiCap}
      className={className}
    />
  );
}

/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * ➕ `GD-07B` 11/09/2026 — CÂU BỊ CHẶN DẠNG CHUỖI TRẦN, cho những chỗ KHÔNG vẽ được một cái
 * băng: một `title=` trên tay kéo, một `aria-label`, một dòng gợi ý trong hộp thoại.
 *
 * 🔴 VÌ SAO NÓ PHẢI Ở ĐÂY chứ không phải chỗ gọi tự nhập `cauChanCoTuyen`: luật của tệp này là
 *   *"`cauChanCoTuyen` chỉ được gọi Ở ĐÂY"*, và luật ấy có phép canh. Bản đầu của `GD-07B` tôi
 *   gõ tay một câu riêng cho cái tay kéo (*"Không có quyền sửa lịch tuyến này"*) — bộ kiểm đỏ,
 *   và nó đỏ đúng: câu gõ tay ấy đúng ở MỘT ca và sai ở ba ca còn lại (tủ chưa gán tuyến ·
 *   tài khoản chưa được gán tuyến · thiếu đúng cái cờ). Sau đó tôi nhập thẳng `cauChanCoTuyen`
 *   vào trang — bộ kiểm lại đỏ, và cũng đúng: một lời gọi thứ hai là một chỗ thứ hai sẽ trôi.
 * ⇒ Lối ra KHÔNG phải nới phép canh, mà là mở đúng một cửa **ở chính nơi giữ luật**.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * ➕ `GD-09` mục 4 — Ổ KHOÁ **CHỈ LÀ BIỂU TƯỢNG**, cho những chỗ không có chỗ cho một câu:
 * một dòng menu, một ô bảng chật.
 *
 * 🔴 VÌ SAO NÓ PHẢI Ở ĐÂY: luật của tệp này là *"biểu tượng ổ khoá chỉ vẽ ở `Khoa.tsx`"*, và
 *   luật ấy có phép canh. Bản đầu của `GD-09` tôi nhập thẳng `Lock` của `lucide-react` vào
 *   `Layout.tsx` — bộ kiểm đỏ, và nó đỏ ĐÚNG: hai chỗ tự vẽ một cái ổ khoá là hai cái ổ khoá
 *   sẽ khác nhau (cỡ, nét, màu), và người dùng học "hình này = khoá" bằng mắt, không bằng tên
 *   lớp CSS.
 * ⇒ Lối ra KHÔNG phải nới phép canh, mà là mở đúng một cửa **ở chính nơi giữ luật** — y như
 *   `cauKhoaTuyen()` đã làm ở `GD-07B`.
 * ⚠ KHÔNG kèm chữ: câu đầy đủ (*thiếu tick nào, ai cấp*) nằm ở trang đích. Ở menu nó chỉ cần
 *   nói "có khoá" và giữ ĐÚNG hình ấy.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
export function OKhoaNho({ className = '', nhan = 'Chưa được cấp quyền' }: {
  className?: string; nhan?: string;
}) {
  return <LockClosed16Regular className={`text-canh ${className}`} aria-label={nhan} />;
}

export function cauKhoaTuyen(
  qd: QuyetDinhCoTuyen | 'khong-co-tuyen' | 'chua-biet', co: CoTuyen,
): string {
  /*
   * ➕ `GD-09` — chưa hỏi xong máy chủ thì nói ĐÚNG thế, không mượn một trong bốn câu kia.
   * ➕ `GD-09b` — và câu ấy đọc từ `CAU_DANG_KIEM`, không gõ lại: xem khối chú thích ở đó.
   */
  if (qd === 'chua-biet') return CAU_DANG_KIEM;
  return cauChanCoTuyen(qd, co);
}

/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * ➕ `GD-09b` 14/09/2026 — BỌC MỘT NÚT THEO **QUYẾT ĐỊNH CỜ TUYẾN**, ba ca chứ không hai.
 *
 * 🔴 LỖI ĐƯỢC SỬA: ba trang đang viết cùng một câu điều kiện hai vế —
 *       `duocDieuKhien ? <Button/> : <Khoa ten={NHAN_CO_TUYEN.canControl}>…</Khoa>`
 *   `duocDieuKhien` là `qd === 'cho-qua'`, nên ca `'chua-biet'` **rơi vào vế `else`** và màn
 *   hình vẽ khung hổ phách + *"Không có quyền: Bật/tắt đèn"* trong lúc chưa ai hỏi xong `/me`.
 *   Đúng cái lỗi `GD-09` đã sửa cho huy hiệu thẻ tuyến — nhưng chỉ sửa ở thẻ tuyến, nên nó
 *   sống tiếp ở ba chỗ khác. `daBietQuyen` mở ra ca thứ ba; một `? :` chỉ có hai nhánh.
 * ⛔ VÀ ĐÂY LÀ LÝ DO NÓ LÀ MỘT HÀM CHỨ KHÔNG PHẢI MỘT CHỈ DẪN: "nhớ thêm nhánh thứ ba" là thứ
 *   quên được ở trang thứ tư. Một tham số `qd` thì **không có chỗ để quên** — chỗ gọi không
 *   còn cầm `boolean` nữa. `[112]` đếm: không trang nào được `? <Khoa` theo cờ tuyến.
 * ⚠ `'chua-biet'` VẪN KHÔNG BẤM ĐƯỢC (hỏng về phía đóng): chưa biết thì chưa cho gửi lệnh
 *   xuống tủ. Cái đổi là **màu và câu chữ**, không phải cái cổng.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
export function KhoaTheoTuyen({
  qd, co, children, hienHuyHieu = true, className = '', trungTinh = false,
}: {
  qd: QuyetDinhCoTuyen | 'khong-co-tuyen' | 'chua-biet';
  co: CoTuyen;
  children: ReactNode;
  hienHuyHieu?: boolean;
  className?: string;
  trungTinh?: boolean;
}) {
  if (qd === 'cho-qua') return <>{children}</>;
  if (qd === 'chua-biet') {
    return <BocDangDo hienHuyHieu={hienHuyHieu} className={className}>{children}</BocDangDo>;
  }
  return (
    <Khoa
      ten={NHAN_CO_TUYEN[co]}
      moTa={cauChanCoTuyen(qd, co)}
      hienHuyHieu={hienHuyHieu}
      className={className}
      trungTinh={trungTinh}
    >
      {children}
    </Khoa>
  );
}

/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * ➕ `GD-09b` 14/09/2026 — BẢN TẦNG TICK của `KhoaTheoTuyen`, và nó ra đời từ MỘT TẤM ẢNH.
 *
 * 🔴 Ảnh tự chụp `gd09b-chuabiet-trang-tu.png`: mọi thứ `GD-09b` vừa sửa đều XÁM đúng — băng
 *   khối, nút "Trả quyền về tự động", ba thẻ ngõ ra — và ở góc trên phải vẫn sáng một huy hiệu
 *   HỔ PHÁCH: *"🔒 Không có quyền: Đổi ngưỡng bảo vệ, cài đặt tủ"*. Cùng một lỗi, cách một tầng:
 *   `coQuyen()` đọc `user?.quyen ?? []`, và `?? []` biến "máy chủ chưa nói" thành "không có tick
 *   nào" — đúng cái `?? []` mà `GD-09` đã cắt ở tầng TUYẾN mà chưa cắt ở tầng TICK.
 * ⛔ VÀ TÔI CHỈ BIẾT VÌ ĐÃ MỞ ẢNH RA XEM. `tsc`, bộ kiểm, bộ phá đều đọc **thứ tôi viết**; chỉ
 *   tấm ảnh đọc **thứ trình duyệt vẽ**. Đây là lần thứ hai luật `L-TỰ-CHỤP` trả tiền vé.
 * ⚠ Hàm này TỰ HỎI `useAuth()`, không nhận `boolean` từ chỗ gọi — cùng lý do với `KhoaTheoTuyen`:
 *   một `boolean` đã đánh mất ca thứ ba TRƯỚC KHI tới đây, và không ai lấy lại được.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
export function KhoaTheoTick({
  khoa, children, hienHuyHieu = true, className = '',
}: {
  khoa: string;
  children: ReactNode;
  hienHuyHieu?: boolean;
  className?: string;
}) {
  const { coQuyen: hoi, daBietQuyen } = useAuth();
  if (!daBietQuyen) {
    return (
      <BocDangDo hienHuyHieu={hienHuyHieu} className={className} cau={CAU_DANG_KIEM_TICK}>
        {children}
      </BocDangDo>
    );
  }
  if (hoi(khoa)) return <>{children}</>;
  return (
    <Khoa ten={NHAN_KHOA[khoa] ?? khoa} hienHuyHieu={hienHuyHieu} className={className}>
      {children}
    </Khoa>
  );
}

/** Tên đọc được của một khoá tick — để chỗ gọi khỏi nhập `NHAN_KHOA` rồi tự ghép. */
export const tenKhoaTick = (khoa: string): string => NHAN_KHOA[khoa] ?? khoa;
